import { FC } from 'react';

const flagUrl = 'https://purecatamphetamine.github.io/country-flag-icons/3x2/';

export type Props = {
    countryCode: string;
    width?: number;
    height?: number;
};

export const Flag: FC<Props> = ({ countryCode, width, height }) => {
    return <img alt={countryCode} src={`${flagUrl}${countryCode}.svg`} width={width} height={height} />;
};
